import { Container } from "react-bootstrap";
import { Search, Categories, ResultImages, Loader, Error } from "./components";
import { useGetPhotoByTagsQuery } from "./api/flickerCore";
import { useState } from "react";

function App() {
  const defaultCategories = [
    { id: "mountain", title: "Mountain" },
    { id: "beaches", title: "Beaches" },
    { id: "birds", title: "Birds" },
    { id: "food", title: "Food" },
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const [tag, setTag] = useState("mountain");
  const [data, isFetching, error] = useGetPhotoByTagsQuery(searchTerm || tag);

  const handleUpdateTag = (newTag) => {
    if (!newTag) return;
    setTag(newTag);
  };

  return (
    <>
      <header className="pt-5 pb-3 px-2 mb-2">
        <Container>
          <h1 className="text-center">Snap Shot</h1>
        </Container>
      </header>
      <main>
        <Search setSearchTerm={setSearchTerm} />
        <Categories
          defaultCategories={defaultCategories}
          handleUpdateTag={handleUpdateTag}
        />
        {isFetching && <Loader />}
        {!isFetching && error && <Error />}
        {!isFetching && data && (<ResultImages photos={data} />)}
      </main>
    </>
  );
}

export default App;
